import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { CategoryService } from 'src/app/api/catalog/category.service';
import { map } from 'rxjs';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { GeneralService } from 'src/app/api/config/general.service';
import { ToolsService } from 'src/app/utils/tools.service';
import * as moment from 'moment';
import { SearchClientComponent } from 'src/app/components/search-client/search-client.component';
import { ClientExtendsComponent } from 'src/app/sale/client/client-extends/client-extends.component';
import { BookingsService } from 'src/app/api/booking/bookings.service';
import { SearchTourComponent } from 'src/app/components/search-tour/search-tour.component';
import { BookingsHotelExtendsComponent } from '../bookings-hotel-extends/bookings-hotel-extends.component';
import { SearchEmployeeComponent } from 'src/app/components/search-employee/search-employee.component';
import { SearchPackagetourComponent } from 'src/app/components/search-packagetour/search-packagetour.component';
import SwalAlert from 'src/app/utils/swalalert';
import { PackagetourService } from 'src/app/api/tourism/packagetour.service';
import { HttpHeaders } from '@angular/common/http';
declare var $: any;

@Component({
  selector: 'app-bookings-form',
  templateUrl: './bookings-form.component.html',
  styleUrls: ['./bookings-form.component.css']
})
export class BookingsFormComponent implements OnInit, AfterViewInit {
  @ViewChild(SearchClientComponent) SearchClientComponent: any;
  @ViewChild(SearchEmployeeComponent) SearchEmployeeComponent: any;
  @ViewChild(SearchPackagetourComponent) SearchPackagetourComponent: any;
  @ViewChild(SearchTourComponent) SearchTourComponent: any;
  @ViewChild(ClientExtendsComponent) ClientExtendsComponent: any;
  @ViewChild(BookingsHotelExtendsComponent) BookingsHotelExtendsComponent: any;

  private thisComponent: BookingsFormComponent;
  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;
  isLoadEdit: boolean = false;

  isClientSelected: boolean = false;
  clientSelected: any = {};
  employeeSelected: any = null;
  packagetourSelected: any = null;
  view_itinerary: boolean = false;

  //init variables
  originsbooking: any = [];
  arrivalplaces: any = [];
  vehiclestours: any = [];
  shifttours: any = [];
  workinggroups: any = [];

  // array variables
  detail_tours: any = [];
  detail_hotels: any = [];
  // saldo pendiente
  difference_balance: number = 0;

  // fortmat pdf
  selectedPdfFileFlight: any | null = null;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private el: ElementRef,
    private renderer: Renderer2,
    private globalService: GlobalService,
    private generalService: GeneralService,
    private bookingsService: BookingsService,
    private packagetourService: PackagetourService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private navigationTrackerService: NavigationTrackerService,
    private alert: SwalAlert
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.thisComponent = this;

    this.item = this.fb.group({
      client_id: [null, [Validators.required]],
      bookingorigin_id: [1, [Validators.required]],
      arrivalplace_id: [null],
      employee_id: [null],
      workinggroup_id: [null],
      tel_1: [null, [Validators.required]],
      tel_2: [null],
      nro_pax: [null, [Validators.required]],
      is_reference_pax: [false],
      nro_pax_childs: [null],
      nro_pax_adults: [null],
      nro_pax_olds: [null],
      date_arrival: [null],
      date_departure: [null],
      time_arrival: [null],
      reference_voucher: [null],
      observations: [null],
      arrival_place: [null],
      reference_location: [null],
      contact_emergency: [null],
      telephone_emergency: [null],
      register_flight: [null],
      is_favorite: [false],
      is_breakfast: [false],
      nro_breakfast: [null],
      start_breakfast: [null],
      end_breakfast: [null],
      // itinerario del paquete
      is_itinerary: [false],
      is_packagetour: [true],
      is_cotization: [false],
      packagetour_id: [null],
      title_itinerary: [null],
      itinerary: [''],
      url_file_flight: [null],

      // totals
      is_detail_subtotaltour: [false],
      is_detail_subtotalhotel: [false],
      subtotal_tour: [0],
      subtotal_hotel: [0],
      subtotal_flight: [0],
      // reserva solo hotel
      is_book_hotel: false,

      total: [0],
      total_paid: [0],
      text_amount: [null]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    this.getOriginBooking();
    this.getArrivalBooking();
    this.getVehicleTour();
    this.getShiftTours();
    this.getWorkingGroup();
    if (this.isEdit) {
      this.editData();
    } else {
      this.generateCalendarDateArrival();
    }
    // setTimeout(() => {
    // }, 150);
    this.navigationTrackerService.initializeMenu(this.route);
  }

  editData() {
    this.bookingsService.get(this.checkId).subscribe({
      next: (data: any) => {
        let item_ = data.data.item;
        this.item.patchValue({
          client_id: item_.client_id,
          bookingorigin_id: item_.bookingorigin_id,
          arrivalplace_id: item_.arrivalplace_id,
          workinggroup_id: item_.workinggroup_id,
          // tel_1: [null, [Validators.required]],
          // tel_2: [null],
          nro_pax: item_.nro_pax,
          is_reference_pax: item_.is_reference_pax,
          nro_pax_childs: item_.nro_pax_childs,
          nro_pax_adults: item_.nro_pax_adults,
          nro_pax_olds: item_.nro_pax_olds,
          date_arrival: item_.date_arrival,
          date_departure: item_.date_departure,
          time_arrival: item_.time_arrival,
          reference_voucher: item_.reference_voucher,
          observations: item_.observations,
          arrival_place: item_.arrival_place,
          reference_location: item_.reference_location,
          contact_emergency: item_.contact_emergency,
          telephone_emergency: item_.telephone_emergency,
          register_flight: item_.register_flight,
          is_favorite: item_.is_favorite,
          is_breakfast: item_.is_breakfast,
          nro_breakfast: item_.nro_breakfast,
          start_breakfast: item_.start_breakfast,
          end_breakfast: item_.end_breakfast,
          // totals
          is_detail_subtotaltour: item_.is_detail_subtotaltour,
          is_detail_subtotalhotel: item_.is_detail_subtotalhotel,
          subtotal_tour: item_.subtotal_tour,
          subtotal_hotel: item_.subtotal_hotel,
          subtotal_flight: item_.subtotal_flight,
          //itinerary
          is_itinerary: item_.is_itinerary,
          is_packagetour: item_.is_packagetour,
          is_cotization: item_.is_cotization,
          packagetour_id: item_.packagetour_id,
          title_itinerary: item_.title_itinerary,
          itinerary: item_.itinerary,
          url_file_flight: item_.url_file_flight,
          //reserva solo hotel
          is_book_hotel: item_.is_book_hotel,
          //=====
          total: item_.total,
          total_paid: item_.total_paid,
          text_amount: item_.text_amount
        });

        // calcular saldo pendiente
        // this.difference_balance = Number(item_.total) - Number(item_.total_paid);

        this.view_itinerary = item_.is_itinerary;
        this.detail_tours = data.data.tours;
        this.detail_hotels = data.data.hotels;
        this.selectedClientSearch(item_.client_data);
        if (item_.employee_id != null) {
          this.selectedEmployeeSearch(item_.employee_data);
        }

        if (item_.packagetour_id != null) {
          this.isLoadEdit = true;
          item_.packagetour_data.description = item_.title_itinerary;
          item_.packagetour_data.include = item_.itinerary;
          this.selectedPackagetourSearch(item_.packagetour_data);
        }

        setTimeout(() => {
          this.generateDetailTours();
          this.generateCalendarDateArrival();
        }, 150);
      }
    });
  }

  generateDetailTours() {
    for (let index in this.detail_tours) {
      let tour_ = this.detail_tours[index];
      let component_ = this.thisComponent;
      let mindate: any = new Date();
      if (this.isEdit) {
        mindate = null;
      }
      // date assigned ---------
      (<any>$('#date_assigned' + index)).daterangepicker({
        singleDatePicker: true,
        autoUpdateInput: false,
        showDropdowns: true,
        autoApply: true,
        locale: {
          format: 'YYYY-MM-DD'
        }
      }).on('apply.daterangepicker', function(ev:any, picker:any) {
          (<any>$('#date_assigned' + index)).val(picker.startDate.format('YYYY-MM-DD'));
          component_.setDateAssigned(index, picker.startDate.format('YYYY-MM-DD'));
      });
      // (<any>$('#date_assigned' + index)).daterangepicker(
      //   {
      //     singleDatePicker: true,
      //     autoUpdateInput: false,
      //     showDropdowns: true,
      //     autoApply: true,
      //     minDate: mindate,
      //     locale: {
      //       format: 'YYYY-MM-DD'
      //     }
      //   },
      //   function(chosen_date: any) {
      //     (<any>$('#date_assigned' + index)).val(
      //       chosen_date.format('YYYY-MM-DD')
      //     );
      //     component_.setDateAssigned(index, chosen_date.format('YYYY-MM-DD'));
      //   }
      // );
      if (!this.isEdit) {
        // (<any>$('#date_assigned' + index)).val(null);
      }

      // vehicle tours ---------
      (<any>$('#vehicleTourSelected' + index)).html('');
      for (let i in this.vehiclestours) {
        let item_ = this.vehiclestours[i];
        (<any>$('#vehicleTourSelected' + index)).append(
          $('<option>', {
            value: item_.id,
            text: item_.description
          })
        );
      }
      (<any>$('#vehicleTourSelected' + index)).val(tour_.vehicle_tour);

      // shift tours ---------
      (<any>$('#shiftTourSelected' + index)).html('');
      for (let i in this.shifttours) {
        let item_ = this.shifttours[i];
        (<any>$('#shiftTourSelected' + index)).append(
          $('<option>', {
            value: item_.id,
            text: item_.description
          })
        );
      }
      (<any>$('#shiftTourSelected' + index)).val(tour_.shift_tour);
    }
  }

  generateCalendarDateArrival() {
    let component_ = this.thisComponent;
    let mindate: any = null;
    if (this.item.value.date_arrival == null) {
      mindate = new Date();
    }
    (<any>$('#date_arrival')).daterangepicker(
      {
        singleDatePicker: true,
        autoUpdateInput: false,
        showDropdowns: true,
        autoApply: true,
        minDate: mindate,
        locale: {
          format: 'YYYY-MM-DD'
        }
      },
      function(chosen_date: any) {
        (<any>$('#date_arrival')).val(chosen_date.format('YYYY-MM-DD'));
        component_.setDateArrival(chosen_date.format('YYYY-MM-DD'));
      }
    );

    (<any>$('#date_departure')).daterangepicker(
      {
        singleDatePicker: true,
        autoUpdateInput: false,
        showDropdowns: true,
        autoApply: true,
        minDate: mindate,
        locale: {
          format: 'YYYY-MM-DD'
        }
      },
      function(chosen_date: any) {
        (<any>$('#date_departure')).val(chosen_date.format('YYYY-MM-DD'));
        component_.setDateDeparture(chosen_date.format('YYYY-MM-DD'));
      }
    );
  }

  setDateArrival(date_assigned: any) {
    this.item.patchValue({
      date_arrival: date_assigned
    });
  }

  setDateDeparture(date_assigned: any) {
    this.item.patchValue({
      date_departure: date_assigned
    });
  }

  ngAfterViewInit(): void {
    this.SearchClientComponent.focused();
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }


  // FUNCTIONS LOADS DATAS

  getOriginBooking() {
    this.generalService.listOriginBooking().subscribe({
      next: (data: any) => {
        this.originsbooking = data;
      }
    });
  }

  getArrivalBooking() {
    this.generalService.listArrivalBooking().subscribe({
      next: (data: any) => {
        this.arrivalplaces = data;
      }
    });
  }

  getVehicleTour() {
    this.generalService.listVehiclesTours().subscribe({
      next: (data: any) => {
        this.vehiclestours = data;
      }
    });
  }

  getShiftTours() {
    this.generalService.listShiftTours().subscribe({
      next: (data: any) => {
        this.shifttours = data;
      }
    });
  }

  getWorkingGroup() {
    this.generalService.listWorkingGroup().subscribe({
      next: (data: any) => {
        this.workinggroups = data.results;
      }
    });
  }

  selectedClientSearch(item_: any) {
    this.isClientSelected = true;
    this.clientSelected = item_;
    this.item.patchValue({
      client_id: item_.id,
      tel_1: item_.cellphone,
      tel_2: item_.telephone
    });
  }

  removeClient() {
    this.isClientSelected = false;
    this.clientSelected = {};
    this.item.patchValue({
      client_id: null
    });
    setTimeout(() => {
      this.SearchClientComponent.focused();
    }, 150);
  }

  extendsClient(event: any): void {
    this.selectedClientSearch(event);
  }

  selectedEmployeeSearch(item_: any) {
    this.employeeSelected = item_;
    this.item.patchValue({
      employee_id: item_.id
    });
  }

  removeEmployee() {
    this.employeeSelected = null;
    this.item.patchValue({
      employee_id: null
    });
    setTimeout(() => {
      this.SearchEmployeeComponent.focused();
    }, 150);
  }

  specifiedItinerary() {
    let val_ = this.item.value.is_itinerary;
    if (val_) {
      this.view_itinerary = true;
    } else {
      this.view_itinerary = false;
      this.packagetourSelected = null;
      this.item.patchValue({
        packagetour_id: null,
        title_itinerary: null,
        itinerary: null
      });
    }
  }

  selectedPackagetourSearch(item_: any) {
    this.packagetourSelected = item_;
    if (this.isLoadEdit) {
      this.item.patchValue({
        packagetour_id: item_.id,
        itinerary: item_.include
      });
      this.isLoadEdit = false;
    } else {
      this.item.patchValue({
        packagetour_id: item_.id,
        title_itinerary: item_.description,
        itinerary: item_.include
      });
    }
  }

  removePackagetour() {
    this.packagetourSelected = null;
    this.item.patchValue({
      packagetour_id: null,
      title_itinerary: null,
      itinerary: ''
    });
    setTimeout(() => {
      this.SearchPackagetourComponent.focused();
    }, 150);
  }

  selectedTourSearch(item_: any) {
    if (this.toolsService.notExistObjInArr(item_, this.detail_tours)) {
      item_.quantity = null;
      item_.date_assigned = null;
      item_.date_realized = null;
      item_.observation = null;
      item_.price = null;
      item_.subtotal = 0;
      item_.is_open = false;
      this.detail_tours.push(item_);

      setTimeout(() => {
        this.initialDateAssigned(item_, this.thisComponent);
        this.initialVehicleTour(item_);
        this.initialShiftTour(item_);
      }, 100);

      // this.recalculateTotalTour();
    } else {
      this.alertifyMsg.warning(
        'El tour ' + item_.description + ' ya se encuentra agregado'
      );
    }
  }

  initialDateAssigned(tour: any, component: any) {
    var index = this.detail_tours.indexOf(tour);
    this.detail_tours[index].null = null;
    (<any>$('#date_assigned' + index)).daterangepicker({
        singleDatePicker: true,
        autoUpdateInput: false,
        showDropdowns: true,
        autoApply: true,
        locale: {
          format: 'YYYY-MM-DD'
        }
    }).on('apply.daterangepicker', function(ev:any, picker:any) {
        (<any>$('#date_assigned' + index)).val(picker.startDate.format('YYYY-MM-DD'));
        component.setDateAssigned(index, picker.startDate.format('YYYY-MM-DD'));
    });
    // (<any>$('#date_assigned' + index)).daterangepicker(
    //   {
    //     singleDatePicker: true,
    //     autoUpdateInput: false,
    //     showDropdowns: true,
    //     autoApply: true,
    //     // minDate: new Date(),
    //     locale: {
    //       format: 'YYYY-MM-DD'
    //     }
    //   },
    //   function(chosen_date: any) {
    //     console.log("test");
    //     console.log(chosen_date);
    //     (<any>$('#date_assigned' + index)).val(
    //       chosen_date.format('YYYY-MM-DD')
    //     );
    //     component.setDateAssigned(index, chosen_date.format('YYYY-MM-DD'));
    //   }
    // );
  }

  setDateAssigned(index: any, date_assigned: any) {
    this.detail_tours[index].date_assigned = date_assigned;
  }

  initialVehicleTour(tour: any) {
    var index = this.detail_tours.indexOf(tour);
    var options = this.vehiclestours;
    (<any>$('#vehicleTourSelected' + index)).html('');
    for (let i in options) {
      let item_ = options[i];
      (<any>$('#vehicleTourSelected' + index)).append(
        $('<option>', {
          value: item_.id,
          text: item_.description
        })
      );
    }

    (<any>$('#vehicleTourSelected' + index)).val(options[0].id);
    this.detail_tours[index].vehicle_tour = options[0].id;
  }

  initialShiftTour(tour: any) {
    let index = this.detail_tours.indexOf(tour);
    let options = this.shifttours;
    (<any>$('#shiftTourSelected' + index)).html('');
    for (let i in options) {
      let item_ = options[i];
      (<any>$('#shiftTourSelected' + index)).append(
        $('<option>', {
          value: item_.id,
          text: item_.description
        })
      );
    }

    (<any>$('#shiftTourSelected' + index)).val(tour.shift);
    this.detail_tours[index].shift_tour = tour.shift;
  }

  changeVehicleTour(param: any, index: number): void {
    this.detail_tours[index].vehicle_tour = param.value;
  }

  changeShiftTour(param: any, index: number): void {
    this.detail_tours[index].shift_tour = param.value;
  }

  changeToursQuantity(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.detail_tours[index].quantity = value_;
    }
  }

  changeToursObservation(param: any, index: number): void {
    this.detail_tours[index].observation = param.value;
  }

  changeIsOpen(index: number) {
    if (this.detail_tours[index].is_open) {
      this.detail_tours[index].is_open = false;
      const currentDate: Date = new Date();
      (<any>$('#date_assigned' + index)).val(moment().format('YYYY-MM-DD'));
    } else {
      this.detail_tours[index].is_open = true;
      this.detail_tours[index].date_assigned = null;
      (<any>$('#date_assigned' + index)).val(null);
    }
  }

  removeTour(id: any, index: any) {
    this.detail_tours.splice(index, 1);
  }

  changeToursQuantityGeneral(param: any): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      for (let index in this.detail_tours) {
        if(!this.detail_tours[index].is_realized){
          this.detail_tours[index].quantity = value_;
        }
      }
    }
  }

  // hotel booking
  extendsBookingHotel(data: any) {
    let obj_: any = {};
    obj_.id = data.item.id;
    obj_.index = data.item.index;
    obj_.hotel_id = data.item.hotel_id;
    obj_.tradename = data.hotel.tradename;
    obj_.reference_voucher = this.item.value.reference_voucher;
    obj_.cellphone = data.hotel.cellphone;
    obj_.citietouristic = data.hotel.citietouristic.description;
    obj_.detail_bedrooms = data.detail_bedrooms;
    obj_.total = data.total_booking;
    obj_.total_sale = 0;
    obj_.total_paid = 0;

    if (data.isEdit) {  
      let index;
      if(obj_.id != null){
        let update_ = this.toolsService.searchObjById(
          obj_.id,
          this.detail_hotels
        );
        index = this.detail_hotels.indexOf(update_);
      } else{
        index = obj_.index;
      }  

      this.detail_hotels[index] = obj_;
      this.alertifyMsg.success(
        'El registro de hotel ' + obj_.tradename + ' ha sido actualizado'
      );
    } else {
      this.detail_hotels.push(obj_);
      this.alertifyMsg.success('Registro de hotel agregado con éxito');
      // if (this.toolsService.notExistObjInArr(obj_, this.detail_hotels)) {
      //   this.detail_hotels.push(obj_);
      //   this.alertifyMsg.success('Registro de hotel agregado con éxito');
      // } else {
      //   this.alertifyMsg.warning(
      //     'El hotel ' + obj_.tradename + ' ya se encuentra agregado'
      //   );
      // }
    }
  }

  removeDetailHotel(index: any, data_hotel: any) {
    console.log(data_hotel);
    let validation = false;
    for (let i in data_hotel.detail_bedrooms) {
      if(data_hotel.detail_bedrooms[i].is_paid){
        validation = true;
        break;
      }
    }

    if(validation){
      // this.alertifyMsg.warning('Existe un registro en * REPORTE CUADRE *, por lo que no se puede eliminar');
      this.alert.msgWarning('Existe un registro en * REPORTE CUADRE DE HOTEL *, por lo que no se puede eliminar el registro');
    }else{
      this.detail_hotels.splice(index, 1);
      this.alertifyMsg.warning('El hotel ' + data_hotel.tradename + ' ha sido removido');
    }
    
  }

  calculateTotal() {
    let total_ = 0;
    let calc_ =
      total_ +
      (
        Number(this.item.value.subtotal_tour) +
        Number(this.item.value.subtotal_hotel)
      ).toFixed(2);
    this.item.patchValue({
      total: calc_
    });
  }

  importTourPackagetour() {
    let options = {
      title: '¿Estás segur@?',
      message:
        '¿Esta seguro(a) de importar los TOURS DEL PAQUETE TURISTICO ASOCIADO: ' +
        this.packagetourSelected.description +
        ' ?',
      cancel: 'Cancelar',
      confirm: 'Sí, IMPORTAR'
    };
    this.alert.confirmInfo(options).then((result: any) => {
      if (result.isConfirmed) {
        this.detail_tours = [];
        this.packagetourService
          .getToursAssociates(this.packagetourSelected.id)
          .subscribe({
            next: (data: any) => {
              this.detail_tours = data.data;
              console.log(this.detail_tours);
              for (let index in this.detail_tours) {
                this.detail_tours[index].quantity = null;
                this.detail_tours[index].date_assigned = null;
                this.detail_tours[index].date_realized = null;
                this.detail_tours[index].observation = null;
                this.detail_tours[index].price = null;
                this.detail_tours[index].price = null;
                this.detail_tours[index].subtotal = 0;
                this.detail_tours[index].is_open = false;
                this.detail_tours[
                  index
                ].vehicle_tour = this.vehiclestours[0].id;
                this.detail_tours[index].shift_tour = this.detail_tours[
                  index
                ].shift;
              }
              setTimeout(() => {
                this.generateDetailTours();
              }, 250);
            }
          });
      }
    });
  }

  onFileSelectedFlight(event: any): void {
    const file: File = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      if (this.validateSizeImg(file)) {
        this.selectedPdfFileFlight = file;
      }
    } else {
      this.selectedPdfFileFlight = null;
      (<any>$('#file_pdf')).val(null);
      // alert('Por favor, seleccione un archivo PDF.');
      this.alert.warning('Por favor, seleccione un archivo PDF.');
    }
  }

  validateSizeImg(file: any, isMulti: boolean = false) {
    const maxSize = 1024 * 1024; // 1MB in bytes
    if (file) {
      if (file.size / maxSize > environment.max_size_file) {
        let _txt = 'El tamaño del archivo seleccionado (' + file.name + ')';
        this.alertifyMsg.warning(
          _txt +
            ' excede el límite permitido (1 MB). Elija un archivo más pequeño; ó reduzca el tamaño del archivo.',
          10
        );
        return false;
      }
    }

    return true;
  }

  removeFilePdfFlight() {
    this.item.patchValue({
      url_file_flight: null
    });
  }

  onSubmit() {
    this.submitted = true;
    if (_.isEmpty(this.item.value.date_arrival)) {
      this.item.patchValue({
        date_arrival: null
      });
    }
    if (_.isEmpty(this.item.value.time_arrival)) {
      this.item.patchValue({
        time_arrival: null
      });
    }

    if (this.item.invalid) {
      return;
    }
    let data: any = {};

    if (this.validate()) {
      data.item = this.item.value;
      data.detail_tours = this.detail_tours;
      data.detail_hotels = this.detail_hotels;

      const formData = new FormData();
      const headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');
      formData.append('item', JSON.stringify(data));
      formData.append('detail_tours', JSON.stringify(this.detail_tours));
      formData.append('detail_hotels', JSON.stringify(this.detail_hotels));
      formData.append('url_file_flight', this.selectedPdfFileFlight);

      if (this.isEdit) {
        formData.append('id', JSON.stringify(this.checkId));
        this.bookingsService.updateSave(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.router.navigate([
              this.branchofficeSlug + '/reservas/reserva/detalle',
              this.checkId
            ]);
            // this.editData();
          }
        });
      } else {
        this.bookingsService.save(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.router.navigate([
              this.branchofficeSlug + '/reservas/reserva/detalle',
              data.data.id
            ]);
          }
        });
      }
    }
  }

  validate() {
    // let element = this.el.nativeElement.querySelector('#tours_quantity' + i );
    let obj_ = this.item.value;
    if (_.isNull(obj_.client_id)) {
      this.alertifyMsg.warning('Debe seleccionar el cliente responsable');
      this.SearchClientComponent.focused();
      return false;
    }

    if(this.isEdit){
      if(Number(obj_.total) < Number(obj_.total_paid)){
        console.log("si entra");
        let options = {
          title: '¡Atención!',
          message: 'El total de la reserva NO PUEDE SER MENOR al monto pagado',
        };
        this.alert.warning(options);
        (<any>$('#total_tours')).focus();
        return false;
      }
    }
    

    if (obj_.is_book_hotel) {
      if (this.detail_hotels.length == 0) {
        this.alertifyMsg.warning(
          'Debe agregar al menos un registro para la reserva de alojamiento'
        );
        (<any>$('#add_book_hotel')).focus();
        return false;
      }
    } else {
      //  validate detail tours
      if (this.detail_tours.length > 0) {
        for (let i in this.detail_tours) {
          let _item = this.detail_tours[i];

          if (Number(_item.quantity) == 0 || _.isNull(_item.quantity)) {
            this.alertifyMsg.warning(
              'El N° pax para el tours ' +
                _item.description +
                '  no puede ser igual a cero o estar vacío.'
            );
            this.renderer
              .selectRootElement(
                this.el.nativeElement.querySelector('#tours_quantity' + i)
              )
              .focus();
            return false;
          }

          if (_item.is_open == false) {
            if (_.isNull(_item.date_assigned)) {
              this.alertifyMsg.warning(
                'La fecha asignada para el tours ' +
                  _item.description +
                  ' no puede estar vacío.'
              );
              this.renderer
                .selectRootElement(
                  this.el.nativeElement.querySelector('#date_assigned' + i)
                )
                .focus();
              return false;
            }
          }
        }
      } else {
        this.alertifyMsg.warning(
          'Debe seleccionar al menos un tours para la reserva'
        );
        this.SearchTourComponent.focused();
        return false;
      }
    }

    return true;
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/reservas/reserva/lista']);
  }
}
